import { useCallback } from "react";
import { Country, Currency } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { Product } from "../../../domain/entities/product/Product";
import { TrackingEventName } from "./tracking";
import { useTrackBasketItem } from "./useTrackBasketItem";

interface TrackBasketItemAddedFunctionArgs {
  readonly product: Product;
  readonly currency: Currency;
}

interface TrackBasketItemAddedFunction {
  (args: TrackBasketItemAddedFunctionArgs): void;
}

interface UseTrackBasketItemAddedFunctionArgs {
  readonly country: Country;
  readonly segment: Segment;
  readonly userId: string;
  readonly tradename: Tradename;
}

interface UseTrackBasketItemAddedFunction {
  (agrs: UseTrackBasketItemAddedFunctionArgs): TrackBasketItemAddedFunction;
}

const useTrackBasketItemAdded: UseTrackBasketItemAddedFunction = ({ country, segment, tradename, userId }) => {
  const trackBasketItem = useTrackBasketItem({
    event: TrackingEventName.BASKET_ITEM_ADDED,
    country,
    segment,
    tradename,
    userId,
  });

  const trackBasketItemAdded: TrackBasketItemAddedFunction = useCallback(
    ({ product, currency }) =>
      trackBasketItem({
        product,
        currency,
      }),
    [trackBasketItem],
  );

  return trackBasketItemAdded;
};

export { useTrackBasketItemAdded };
